const PngIcon = ({
    src,
    size = 24,
    color,         // applies a CSS filter to tint the image
    className = '',
    style = {},
    alt = '',
    ...props
  }) => {
    return (
      <img
        src={src}
        width={size}
        height={size}
        alt={alt}
        className={className}
        style={{
          display: 'inline-block',
          objectFit: 'contain',
          ...(color ? { filter: `opacity(1)` } : {}), // see tinting note below
          ...style,
        }}
        {...props}
      />
    );
  };
  
  export default PngIcon;